module.exports = __webpack_public_path__ + "static/mission-img-3-513464fa7d44024926c8c3f99a0938e5.jpg";